module.exports = __webpack_public_path__ + "media/images/Dashboard-f937bf22b0a56e1024420ff09712c3b2.svg";